module.exports = __webpack_public_path__ + "static/img/icon-01.4c0d8d56.png";